import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {EntidadeViewModel} from '../../../../../model/conta/entidade/entidadeVM';

import {catchError, map, Observable, of, throwError} from 'rxjs';
import {DocumentoUploadHelper} from '../../../shared/helper/documento-upload-helper';
import {AppConfigurationService} from '../../base/appConfiguration.service';

@Injectable({
  providedIn: 'root',
})
export class EntidadeService {
  constructor(
    private httpClient: HttpClient,
    private appConfigurationService: AppConfigurationService,
    private documentoUploadHelper: DocumentoUploadHelper,
  ) {}

  cadastrar(entidade: EntidadeViewModel): Observable<any> {
    return this.httpClient.post<any>(`${this.appConfigurationService.apiBaseUrl}/Company`, entidade).pipe(
      map(response => {
        return response;
      }),

      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  atualiar(entidade: EntidadeViewModel): Observable<any> {
    return this.httpClient.put<any>(`${this.appConfigurationService.apiBaseUrl}/Company`, entidade).pipe(
      map(response => {
        return response;
      }),

      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }
  listaEntidades(page: number, itemsPerPage: number): Observable<any> {
    //'https://back-end-stage.azurewebsites.net/api/Company?skip=10&take=500'
    const skip = (page - 1) * itemsPerPage; // Calcular quantos itens pular
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/Company?skip=${skip}&take=${itemsPerPage}`)

      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => new Error(err || 'Erro no servidor'));
        }),
      );
  }

  listarPorId(id: string): Observable<any> {
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/Company/${id}`)

      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => new Error(err || 'Erro no servidor'));
        }),
      );
  }

  deletar(id: any): Observable<any> {
    return this.httpClient.delete<any>(`${this.appConfigurationService.apiBaseUrl}/Company/${id}`).pipe(
      map(response => response),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }
  AtivarOuDesativar(id: any, active: boolean): Observable<any> {
    return this.httpClient
      .put<Number>(`${this.appConfigurationService.apiBaseUrl}/Company/ActiveOrInactive?id=${id}&active=${active}`, {})

      .pipe(
        map(response => response),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  onSalvarDocuments(files: any, idEntidade: any): Observable<Number> {
    const formData = new FormData();

    for (let index = 0; index < files.length; index++) {
      const file = files[index];

      if (typeof file.file == 'string') {
        const fileName = file.fileName + '.' + file.format;

        const newFile = this.documentoUploadHelper.dataURLtoFile(file.dataUrl, fileName, file.format);

        formData.append('file', newFile);
      } else {
        formData.append('file', file.file);
      }
    }

    return this.httpClient
      .post<Number>(`${this.appConfigurationService.apiBaseUrl}/Company/Upload?IdCompany=${idEntidade}`, formData)
      .pipe(
        map(response => {
          return response;
        }),

        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  buscarRegsitroEntidadePorPropostaAdservip(id: string): Observable<any> {
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/EntityRegistrationForm/by-proposal/${id}`)

      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  cadastrarFormEntidadePorProposta(dataVM: any): Observable<any> {
    return this.httpClient
      .post<any>(`${this.appConfigurationService.apiBaseUrl}/EntityRegistrationForm/upsert`, dataVM)
      .pipe(
        map(response => {
          return response;
        }),

        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  cadastrarFormInscricaoEntidadeABJE(dataVM: any): Observable<any> {
    return this.httpClient
      .post<any>(`${this.appConfigurationService.apiBaseUrl}/AbjeRegistrationForm/upsert`, dataVM)
      .pipe(
        map(response => {
          return response;
        }),

        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  listasCamposFormularioABJE(): Observable<any> {
    const dados = {
      envioCorrespondencia: [
        {
          valor: 0,
          nome: 'Residência',
        },
        {
          valor: 1,
          nome: 'Lotação',
        },
        {
          valor: 2,
          nome: 'E-mail',
        },
      ],
      doQuadro: [
        {
          valor: 0,
          nome: 'Ativo',
        },
        {
          valor: 1,
          nome: 'Aposentado',
        },
        {
          valor: 2,
          nome: 'Pensionista',
        },
        {
          valor: 3,
          nome: 'Requisitado',
        },
        {
          valor: 4,
          nome: 'Magistrado',
        },
      ],
      produtos: [
        {
          nome: 'productGeiaUnimedFesp',
          valor: true,
          produto: 'Géia - Unimed Fesp',
          anuidade: 'Anuidade da ABJE isenta para titulares e dependentes, na contratação exclusiva do produto.',
        },
        {
          nome: 'productDental',
          valor: false, // Corrigido: estava 1, deve ser false para consistência
          produto: 'INPAO Dental/OdontoPrev - Planos Odontológicos',
          anuidade:
            'Anuidade da ABJE cobrada do titular do plano conforme tabela de preços vigente. Dependentes são isentos.',
        },
        {
          nome: 'productAnserjufe',
          valor: false,
          produto: 'ANSERJUFE - Seguros Unimed/Unimed Odonto',
          anuidade:
            'Anuidade da ABJE isenta para titulares e dependentes, na contratação exclusiva do produto. O associado deverá pagar a anuidade para a ANSERJUFE conforme  tabela de preços vigente.',
        },
        {
          nome: 'productLegalAndBond',
          valor: false,
          produto: 'Serviços Jurídicos e Carta de Fiança',
          anuidade: 'Anuidade da ABJE cobrada do associado titular conforme tabela de preços vigente.',
        },
        {
          nome: 'productOtherPartnerships',
          valor: false,
          produto: 'Demais Produtos - Parcerias de Seguros, Hoteis, Viagens, Cursos, etc...',
          anuidade:
            'Anuidade da ABJE cobrada do associado titular conforme tabela de preços vigente, caso não opte por nenhum outro produto oferecido pela ABJE.',
        },
      ],
    };

    return of(dados);
  }

  buscarRegsitroEntidadePorPropostaAbje(id: string): Observable<any> {
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/AbjeRegistrationForm/by-proposal/${id}`)

      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }
}
